import { graphql } from "gatsby";
import React from "react";
import { Collapse } from "react-collapse";
import ReactMarkdown from "react-markdown";
import xss from "xss";

import Card from "../components/Card";
import SubPage from "../components/SubPage";
import * as styles from "../styles/Privacy.module.css";
import pageData from "./../data/privacy.yaml";
import { SEO } from "../components/SEO";

const ContactCard = () => {
  return (
    <div className={styles.po}>
      <div className={styles.po_text_area}>
        <h2>{pageData.privacy_officer.title}</h2>
        <ReactMarkdown>{pageData.privacy_officer.text}</ReactMarkdown>
      </div>
    </div>
  );
};

const Template = ({ data }: { data: any }) => {
  const { markdownRemark } = data;
  const { html, frontmatter } = markdownRemark;
  const [moreInfo, setMoreInfo] = React.useState(false);
  return (
    <SubPage>
      <SEO title={pageData.seo_tags.title} image={pageData.seo_tags.image} description={pageData.seo_tags.description} />
      <div className={styles.container}>
        {pageData.tiles.map((x: any, i: number) => {
          return <Card {...x} key={`Card_${i}`} />;
        })}
      </div>

      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <ContactCard />
      </div>

      <Collapse isOpened={moreInfo}>
        <div dangerouslySetInnerHTML={{ __html: xss(html) }} />
      </Collapse>

      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <button
          className="button button-secondary"
          onClick={() => setMoreInfo(!moreInfo)}
        >
          {moreInfo ? "Hide" : "More Info"}
        </button>
      </div>
    </SubPage>
  );
};

export default Template;

export const pageQuery = graphql`
  query ($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        date(formatString: "YYYY-MM-DD")
        slug
        title
      }
    }
  }
`;
